import { Button } from "@/components/ui/button";

const LEVELS = [["none", "None"], ["view", "View"], ["manage", "Manage"]];

export const PermissionGrid = ({ areas, value, onChange, disabled = false }) => {
  const setAll = (level) => onChange(Object.fromEntries(areas.map((a) => [a.key, level])));
  const groups = [...new Set(areas.map((a) => a.group))];
  return (
    <div className="space-y-3" data-testid="permission-grid">
      {!disabled && (
        <div className="flex gap-2">
          {LEVELS.map(([l, label]) => (
            <Button key={l} type="button" variant="outline" size="sm" onClick={() => setAll(l)} data-testid={`perm-all-${l}`}>All {label}</Button>
          ))}
        </div>
      )}
      {groups.map((g) => (
        <div key={g}>
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1.5">{g}</p>
          <div className="grid sm:grid-cols-2 gap-1.5">
            {areas.filter((a) => a.group === g).map((a) => (
              <div key={a.key} className="flex items-center justify-between px-3 py-1.5 bg-slate-50 rounded-md" data-testid={`permission-row-${a.key}`}>
                <span className="text-sm text-navy">{a.label}</span>
                <div className="flex rounded-md border border-slate-200 overflow-hidden">
                  {LEVELS.map(([l, label]) => (
                    <button key={l} type="button" disabled={disabled} onClick={() => onChange({ ...value, [a.key]: l })}
                      data-testid={`perm-${a.key}-${l}`}
                      className={`px-2 py-0.5 text-[11px] transition-colors ${(value?.[a.key] || "none") === l
                        ? (l === "manage" ? "bg-emerald-600 text-white" : l === "view" ? "bg-blue-600 text-white" : "bg-slate-500 text-white")
                        : "bg-white text-slate-500 hover:bg-slate-100"} ${disabled ? "cursor-not-allowed opacity-70" : ""}`}>
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
